const Types = {
  SET_LEAD: "SET_LEAD",
  FETCH_ERROR: "PAYMENT_FETCH_ERROR",
  SET_ORDER_ID: "SET_ORDER_ID",
  SET_PAYMENT_METHOD: "SET_PAYMENT_METHOD",
};

export const state = {
  IdentificadorPedido: "",
  CPF: "",
  NumeroCartao: "",
  Vencimento: "",
  CodigoSeguranca: "",
  meioPagamento: "cartao",
};

export const getters = {
  getIdentificadorPedido: state => state.IdentificadorPedido,
  getMeioPagamento: state => state.meioPagamento,
};

export const mutations = {
  [Types.SET_LEAD]: (state, lead) => {
    state.lead = { ...lead };
  },
  [Types.SET_ORDER_ID]: (state, IdentificadorPedido) => {
    state.IdentificadorPedido = IdentificadorPedido;
  },
  [Types.SET_PAYMENT_METHOD]: (state, payment) => {
    state.meioPagamento = payment;
  },
};

export const actions = {
  setLead: ({ commit }, lead) => {
    let thisLead = { ...lead };
    thisLead.tel = thisLead.tel.replace("(", "");
    thisLead.tel = thisLead.tel.replace(") ", "");
    thisLead.tel = thisLead.tel.replace("-", "");
    commit(Types.SET_LEAD, thisLead);
  },
  setOrderId: ({ commit }, IdentificadorPedido) => {
    commit(Types.SET_ORDER_ID, IdentificadorPedido);
  },
  setPaymentMethod: ({ commit }, payment) => {
    commit(Types.SET_PAYMENT_METHOD, payment);
  },
};
